import React, { Component } from "react";
import Measure from "react-measure";
import moment from "moment";
import {nest} from 'd3-collection';
import Bubbles from "../components/Bubbles";
import MegaOverlayMenu from "../components/Layout/MegaOverlayMenu";
import { cleanUp, areas } from "../utils";
import "./elezioni.css";

const now = moment().format('H');

class ElezioniContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
      infoBlocks: [],
      dimensions: {
        width: 0,
        height: 0
      },
      showedHours: 24,
    };
  }
  componentDidMount() {
    let SHOWEDHOURS = +now < 12 ? 48 + +now : 24 + +now;
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if(width < 572) {
      SHOWEDHOURS = 24;
    }
    //fetch(`${process.env.PUBLIC_URL}/data/latest.json`)
    fetch(`https://api.elezioni.io/browse/by-hour/${SHOWEDHOURS}`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        // console.log("parsed json", data);
        const blockTimeRanges = [];
        const hours = {};
        const prevs = {};
        const articles = data.articles
          .filter(d => typeof d.dbid === "undefined")
          .filter(d => +d.popularity_logs > 0)
          .sort((a, b) => +new Date(b.date_published) -  +new Date(a.date_published))
          .map((article, i) => {
            article.index = i;

            // time in hours
            const hour = moment(article.date_published).add(1, 'h').format(
              "YYYY-MM-DD HH:00"
            );
            article.hour = hour;

            if (!hours[hour]) {
              hours[hour]={hour,articles:1};
            } else {
              hours[hour].articles++;
            }

            // time in blockTimeRange
            const blockTimeRange = moment(article.date_published).format(
              "YYYY-MM-DD 23:59:59"
            );
            article.blockTimeRange = blockTimeRange;
            if (blockTimeRanges.indexOf(blockTimeRange) === -1) {
              blockTimeRanges.push(blockTimeRange);
            }

            article.originalTitle = article.title;
            article.title = cleanUp(article.title);
            article.slugs = article.collections.map(d => d.slug).sort((a, b) => areas.indexOf(a) - areas.indexOf(b));
            const already = [];
            article.prevs = article.collections.map(collection => {
              const prev = prevs[collection.slug];
              prevs[collection.slug] = article;
              if(prev) {
                already.push(prev.id);
              }

              return prev;
            }).filter(d => typeof d !== 'undefined')

            return article;
          });

        const infoBlocks = nest()
                            .key(d => d.blockTimeRange)
                            .rollup(leaves => {
                              const slugs = {};
                              const sentiments = {};
                              leaves.forEach(d => {
                                d.slugs.forEach(slug => {
                                  if(!slugs[slug]) {
                                    slugs[slug] = 0;
                                  }
                                  slugs[slug]++;
                                })
                              })
                              leaves.forEach(d => {
                                if(!sentiments[d.sentiment]) {
                                  sentiments[d.sentiment] = 0;
                                }
                                sentiments[d.sentiment]++;
                              })
                              return {
                                total: leaves.length,
                                slugs,
                                sentiments,
                              }
                            })
                            .entries(articles)

        this.setState({ articles, blockTimeRanges, hours, infoBlocks, showedHours: SHOWEDHOURS });
      })
      .catch(ex => {
        console.log("parsing failed", ex);
      });
  }

  render() {
    const { articles, infoBlocks, hours, showedHours } = this.state;
    return (
      <div className="elezioni">
        <Measure
          bounds
          onResize={contentRect => {
            if(contentRect.bounds.width !== this.state.dimensions.width) {
              this.setState({
                dimensions: {
                  width: contentRect.bounds.width,
                  height: contentRect.bounds.height
                }
              });
            }
          }}
        >
          {({ measureRef }) => (
            <div className="elezioni-container" ref={measureRef}>
              <Bubbles
                articles={articles}
                infoBlocks={infoBlocks}
                hours={hours}
                fields={{ y: "index" }}
                outlines={20}
                showingHours={showedHours}
                {...this.state.dimensions}
              />
            </div>
          )}
        </Measure>
        <MegaOverlayMenu />
      </div>
    );
  }
}

export default ElezioniContainer;



// WEBPACK FOOTER //
// ./src/elezioni/containers/ElezioniContainer.js